export default "__VITE_PUBLIC_ASSET__34e914e5__"